import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFavoritesByUserId, removeFromFavorites, addToFavorites, } from '../../firebase/config';
import ProductosFav from '../ProductosFav/ProductosFav';
import { ModalCarga } from '../ModalCarga/ModalCarga';
import './Favoritos.css';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';


export const Favoritos = () => {
  const { user, loading: authLoading, premium, planName } = useAuth();
  const [userLikes, setUserLikes] = useState([]);
  const getPlanLimit = (planName) => {
    switch (planName?.toLowerCase()) {
      case 'plan explora':
        return 25;
      case 'plan explora+':
        return 50;
      case 'plan radar':
        return 100;
      case 'plan radar+':
        return 200;
      default:
        return 0;
    }
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user && !premium) {
      navigate('/premium', { replace: true });
    }
  }, [authLoading, user, premium, navigate]);

  useEffect(() => {
    const fetchFavorites = async () => {
      if (user && user.likes) {
        try {
          const favorites = await getFavoritesByUserId(user.likes);
          setUserLikes(favorites);
          localStorage.setItem('favorites', JSON.stringify(favorites)); // Guardar en localStorage
        } catch (error) {
          console.error('Error al obtener favoritos:', error);
        }
      }
    };
    fetchFavorites();
  }, [user]);
  

  const handleLikeClick = async (producto) => {
    if (!user) return;
  
    try {
      if (user.likes.includes(producto.id)) {
        await removeFromFavorites(user.uid, producto.id);
  
        // Eliminar el producto directamente del estado actual
        const updatedLikes = userLikes.filter(p => p.id !== producto.id);
        setUserLikes(updatedLikes);
        localStorage.setItem('favorites', JSON.stringify(updatedLikes));
      } else {
        await addToFavorites(user.uid, producto.id, planName);
  
        // Obtener el nuevo producto y añadirlo al estado actual
        const newFavorites = await getFavoritesByUserId([...user.likes, producto.id]);
        setUserLikes(newFavorites);
        localStorage.setItem('favorites', JSON.stringify(newFavorites));
      }
    } catch (error) {
      console.error('Error al manejar el like:', error);
    }
  };
  
  
  useEffect(() => {
    const savedFavorites = localStorage.getItem('favorites');
    if (savedFavorites) {
      setUserLikes(JSON.parse(savedFavorites));
    }
  }, []);
  

  if (authLoading || !user) {
    return <ModalCarga />;
  }


  return (
    <div className="fav-goblal-container">
      <div className="container-fav">
        <h1>Mis Productos Rastreados</h1>
        <div className="favorites-dashboard">
          <div className="metrics">
            <div className="metric-box">
              <h4>Límite</h4>
              <p>{getPlanLimit(planName)}</p>
            </div>
            <div className="metric-box">
              <h4>Guardados</h4>
              <p>{userLikes.length}</p>
            </div>
            <div className="metric-box">
              <h4>Disponibles</h4>
              <p>{getPlanLimit(planName) - userLikes.length}</p>
            </div>
          </div>

          <div className="progress-bar-container">
            <div
              className="progress-bar-fill"
              style={{
                width: `${
                  getPlanLimit(planName) > 0
                    ? Math.min((userLikes.length / getPlanLimit(planName)) * 100, 100)
                    : 0
                }%`,
              }}
            />
          </div>
        </div>
      </div>
      {userLikes.length > 0 ? (
        <div className="products-container">
          {userLikes.map((favorite) => (
            <ProductosFav 
            key={favorite.id} 
            producto={favorite} 
            premium={premium} 
            planName={planName} 
            user={user}
            handleLikeClick={handleLikeClick}
          />   
          ))}
        </div>
      ) : (
        <div className="container-fav">
          <p>Empieza a añadir productos para rastrear.</p>
          <button>
            <Link to="/" className="buscar-productos-link">Buscar productos</Link>
          </button>
        </div>
      )}
    </div>
  );
};
